import { render, staticRenderFns } from "./reghistory.vue?vue&type=template&id=202fcd9a&scoped=true"
import script from "./reghistory.vue?vue&type=script&lang=js"
export * from "./reghistory.vue?vue&type=script&lang=js"
import style0 from "./reghistory.vue?vue&type=style&index=0&id=202fcd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fcd9a",
  null
  
)

export default component.exports